import { render, staticRenderFns } from "./FmSynthEdit.vue?vue&type=template&id=55fbc7d2&scoped=true&"
import script from "./FmSynthEdit.vue?vue&type=script&lang=js&"
export * from "./FmSynthEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fbc7d2",
  null
  
)

export default component.exports